import Vue from 'vue'
import VueRouter from 'vue-router'
import home from '../views/home.vue'
import empresa from '../views/empresa.vue'
import privacy from "../views/privacy.vue"
import protocolo from "../views/protocolo.vue"

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: "/home",
  },
  {
    path: '/home',
    name: 'home',
    component: home
  },
  {
    path: '/empresa',
    name: 'empresa',
    component: empresa,
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: privacy
  },
  {
    path: '/protocolo',
    name: 'protocolo',
    component: protocolo
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
